import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../firebase-config';
import { UserAuthContext } from '../context/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import MenuHead from './MenuHead';
import { FcLeft } from 'react-icons/fc';
import { useTranslation } from 'react-i18next';
import {
  clientStatusAdm,
  administratorStatusAdm,
} from '../context/FormAdminInput';
import {
  clientTextBox,
  userInputsPersonal,
  userInputsPartner,
  userInputsGeneralQuestions,
  userInputsGeneralQuestionsPartner,
  userInputsEmployment,
  userInputsEmploymentPartner,
  userInputsExpenses,
  userInputsExpensesPartner,
  userInputsEmploymentExpenses,
  userInputsEmploymentExpensesPartner,
  userInputsInvestments,
  userInputsInvestmentsPartner,
  userAuthorize,
  userAuthorizePartner,
  userBankInf,
  userBankInfPartner,
} from '../context/FormSource';
import GridClient from '../components/GridClient';
import LoadingModalPage from './LoadingModalPage';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { Select, Option } from '@material-tailwind/react';

const AdminAccount = () => {
  const { uploadFiles, getUrlDownloadFile, updateClientByAdmin } =
    UserAuthContext();
  const { id } = useParams();
  const [users, setUsers] = useState({});
  const [numberDepend, setNumberDepend] = useState([]);
  const usersCollectionRef = doc(db, '2023', id);
  const navigate = useNavigate();
  const [statusClient, setStatusClient] = useState();
  const [statusAdmin, setStatusAdmin] = useState();
  const [adminNotes, setAdminNotes] = useState();
  const [idToUploadClient, setIdToUploadClient] = useState();
  const [savingForm, setSavingForm] = useState(false);
  const [infoSubmit, setInfoSubmit] = useState(false);
  const [, setSavedForm] = useState(false);
  const [year, setYear] = useState('2023');

  const { t } = useTranslation();

  function backButton() {
    navigate('/admin');
  }

  useEffect(() => {
    const getDocUser = async () => {
      const docSnap = await getDoc(doc(db, year, id));
      setUsers(docSnap.data());
      // if (docSnap.exists()) {
      //   console.log('Doc data ok');
      // } else {
      //   console.log('No Doc');
      // }
    };
    getDocUser();
    // eslint-disable-next-line
  }, [year]);

  useEffect(() => {
    setStatusClient(users?.status ?? 'Initial');
    setStatusAdmin(users?.AdminStatus ?? 'Ready For Review');
    setAdminNotes(users?.AdminTextNoteClient ?? '');
    setIdToUploadClient(usersCollectionRef.id);
  }, [
    year,
    users?.status,
    users?.AdminStatus,
    users?.AdminTextNoteClient,
    usersCollectionRef.id,
  ]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const mapUserData = Object.entries(users);
    if (mapUserData.length < 30) {
      alert('Wait for all the data to load and try again.');
      return;
    }
    setSavingForm(true);
    setInfoSubmit(true);
    const objectFilesMap = {};

    for (const [key, val] of mapUserData) {
      const storagePath = `${year}/${users?.email}/${key}/`;

      if (key === 'AdminFilesUpload' && val.length > 0) {
        const filesUploadUrl = await Promise.all(
          val.map((elem) => {
            if (elem.urlDownloadFile) {
              return elem;
            } else {
              return uploadFiles(storagePath + elem?.name, elem.FileObject);
            }
          }),
        );
        const newUrlLink = await Promise.all(
          filesUploadUrl.map(async (element, index) => {
            if (element.urlDownloadFile) {
              return element;
            } else {
              const getUrlData = await getUrlDownloadFile(element.ref);
              return {
                id: index,
                name: element.ref.name,
                urlDownloadFile: getUrlData,
              };
            }
          }),
        );
        objectFilesMap[key] = newUrlLink;
      } else {
        objectFilesMap[key] = val;
      }
    }
    setUsers(objectFilesMap);

    try {
      const clientDataByAdmin = { ...objectFilesMap };
      await updateClientByAdmin(idToUploadClient, { clientDataByAdmin });
      setUsers(clientDataByAdmin);
      setSavingForm(false);
      console.log('Done!');
    } catch (error) {
      console.log(error);
    }
  };

  const handleInput = (e) => {
    const id = e.target.id;
    const value = e.target.value;
    const typeInput = e.target.type;

    if (typeInput === 'file') {
      const imgData = e?.target?.files;
      const fileUrl = users[id] ? users[id] : [];

      for (let index = 0; index < imgData.length; index++) {
        fileUrl.push({ name: imgData[index].name, FileObject: imgData[index] });
      }

      setUsers({ ...users, [id]: fileUrl });
    } else {
      setUsers({ ...users, [id]: value });
    }
  };

  useEffect(() => {
    const checkArray =
      users?.numberDependet &&
      Array.from(Array(Number(users?.numberDependet)).keys());
    setNumberDepend(checkArray);
  }, [users]);

  const RemoveFileUserdata = (elementArray, index) => {
    if (users?.[elementArray].length === 1)
      document.getElementById(elementArray).value = '';
    users?.[elementArray].splice(index, 1);
    setUsers({ ...users });
  };

  return (
    <>
      {savingForm && <LoadingModalPage loading={true} />}
      {infoSubmit && (
        <LoadingModalPage
          exitAfter={false}
          setSavedForm={setSavedForm}
          setInfoSubmit={setInfoSubmit}
          modal={true}
          title="Saved Information"
          textInside={'Data saved successfully.'}
        />
      )}
      <div className="flex min-h-screen">
        <div className="w-72 bg-[#075985] border-double xl:flex hidden">
          <Sidebar admin={true} />
        </div>
        <div className="flex-1 flex-col">
          <MenuHead status="Admin" />
          <div className="mx-28 py-5 flex gap-8">
            <button
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-medium py-2 px-4 rounded-full flex items-center"
              onClick={backButton}
            >
              <FcLeft size={20} className="mr-2 text-red-600 cursor-pointer" />
              Back to the List
            </button>
            <div>
              <Select
                label={t('year')}
                color="blue-gray"
                value={year}
                onChange={(target) => setYear(target)}
                className="self-center"
              >
                <Option value="2023">2023</Option>
                <Option value="users">2022</Option>
              </Select>
            </div>
          </div>
          {year === 'users' && (
            <div className="my-4 p-4 bg-red-200 text-lg font-bold text-center">
              You are viewing this user's data from 2022!
            </div>
          )}
          {/* All Admin - Send to component */}
          <form
            onSubmit={handleSubmit}
            className="flex flex-col mx-28 bg-blue-gray-50 p-4 rounded-xl text-blue-900"
          >
            <div className="flex flex-row">
              <div className="pr-4 w-1/3">
                <label htmlFor="status" className="block font-medium">
                  Client Status
                </label>
                <select
                  id="status"
                  name="status"
                  value={statusClient}
                  onChange={handleInput}
                  className="block w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                >
                  {clientStatusAdm?.map((elem, i) => {
                    return (
                      <option key={i} value={elem.value}>
                        {t(elem.label)}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="pr-4 w-1/3">
                <label htmlFor="AdminStatus" className="block font-medium">
                  Admin Status
                </label>
                <select
                  id="AdminStatus"
                  name="AdminStatus"
                  value={statusAdmin}
                  onChange={handleInput}
                  className="block w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                >
                  {administratorStatusAdm?.map((e, i) => {
                    return (
                      <option key={i} value={e.value}>
                        {t(e.label)}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="w-1/3">
                <label
                  htmlFor="AdminTextNoteClient"
                  className="block font-medium"
                >
                  Text Area:
                </label>
                <textarea
                  onChange={handleInput}
                  maxLength={900}
                  defaultValue={adminNotes}
                  id="AdminTextNoteClient"
                  name="AdminTextNoteClient"
                  className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                ></textarea>
              </div>
            </div>
            <div>
              <div className="flex">
                <input
                  accept="image/*,.pdf, .xls, .xlsx, .doc, .docx"
                  className="m-1 file:mr-4 file:py-2 file:px-4 self-center
              file:rounded-full file:border
              file:border-indigo-600
              file:text-sm file:font-semibold
              file:bg-blue-500 file:text-white
              hover:file:bg-indigo-600 file:cursor-pointer"
                  type="file"
                  id="AdminFilesUpload"
                  multiple
                  onChange={handleInput}
                />
              </div>
              <div>
                <button
                  type="submit"
                  className="text-white flex mt-4 bg-blue-500 hover:bg-indigo-600 font-medium py-2 px-4 rounded shadow float-right disabled:bg-gray-600 disable:cursor-not-allowed disabled:pointer-events-none"
                  disabled={year === 'users'}
                >
                  Save
                </button>
                {statusAdmin === 'Completed' && (
                  <div className="flex mt-4 font-medium py-2 px-4 rounded shadow float-right mx-3">
                    Prepared to Export
                  </div>
                )}
              </div>
              {users?.AdminFilesUpload?.map((e, i) => {
                return (
                  <div
                    className="flex justify-start items-center cursor-pointer"
                    key={i}
                  >
                    <IoMdCloseCircleOutline
                      size={20}
                      className="mr-2 text-red-600 cursor-pointer"
                      onClick={() => RemoveFileUserdata('AdminFilesUpload', i)}
                    />
                    <a
                      href={e.urlDownloadFile}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {e.name}
                    </a>
                  </div>
                );
              })}
            </div>
            {/* //TODO EmailTemplates */}
            {/* EmailTemplates */}
            {/* <EmailTemplates /> */}
          </form>
          {/* All Admin - Send to component */}
          <div className="flex-col mx-28 mb-20">
            <GridClient
              gridText={'Taxpayer'}
              textBlock={t(clientTextBox[0].label)}
              formGrid={userInputsPersonal}
              userGrid={users}
              gridCols={4}
            />
            <GridClient
              formGrid={userInputsGeneralQuestions}
              textBlock={t(clientTextBox[1].label)}
              userGrid={users}
              gridCols={2}
            />
            <GridClient
              formGrid={userInputsEmployment}
              textBlock={t(clientTextBox[2].label)}
              userGrid={users}
              gridCols={2}
            />
            <GridClient
              formGrid={userInputsExpenses}
              textBlock={t(clientTextBox[3].label)}
              userGrid={users}
              gridCols={2}
            />
            <GridClient
              formGrid={userInputsEmploymentExpenses}
              textBlock={t(clientTextBox[4].label)}
              userGrid={users}
              gridCols={2}
            />
            <GridClient
              formGrid={userInputsInvestments}
              textBlock={t(clientTextBox[5].label)}
              userGrid={users}
              gridCols={2}
            />
            <GridClient
              formGrid={userAuthorize}
              textBlock={t(clientTextBox[6].label)}
              userGrid={users}
              gridCols={1}
            />
            <GridClient
              formGrid={userBankInf}
              textBlock={t(clientTextBox[7].label)}
              userGrid={users}
              gridCols={3}
            />
            {(users?.maritalStatus === 'Married' ||
              users?.maritalStatus === 'Common-Law') && (
              <div className="mt-20">
                <GridClient
                  gridText={'Partner'}
                  textBlock={'Partner Information'}
                  formGrid={userInputsPartner}
                  userGrid={users}
                  gridCols={6}
                />
                {users?.taxTogether === 'Yes' && (
                  <>
                    <GridClient
                      textBlock={'Partner General Questions'}
                      formGrid={userInputsGeneralQuestionsPartner}
                      userGrid={users}
                      gridCols={2}
                    />
                    <GridClient
                      textBlock={'Partner Income'}
                      formGrid={userInputsEmploymentPartner}
                      userGrid={users}
                      gridCols={2}
                    />
                    <GridClient
                      textBlock={'Partner Expenses'}
                      formGrid={userInputsExpensesPartner}
                      userGrid={users}
                      gridCols={2}
                    />
                    <GridClient
                      textBlock={'Partner Employment Expenses'}
                      formGrid={userInputsEmploymentExpensesPartner}
                      userGrid={users}
                      gridCols={2}
                    />
                    <GridClient
                      textBlock={'Partner Investment'}
                      formGrid={userInputsInvestmentsPartner}
                      userGrid={users}
                      gridCols={2}
                    />
                    <GridClient
                      textBlock={'Partner Authorize a representative'}
                      formGrid={userAuthorizePartner}
                      userGrid={users}
                      gridCols={1}
                    />
                    <GridClient
                      textBlock={'Partner Direct Deposit'}
                      formGrid={userBankInfPartner}
                      userGrid={users}
                      gridCols={3}
                    />
                  </>
                )}
              </div>
            )}
            {users?.numberDependet > 0 && (
              <div className="mt-20">
                <h3 className="py-2 pl-4 text-2xl font-bold text-blue-600">
                  Dependant(s)
                </h3>
              </div>
            )}
            {numberDepend &&
              numberDepend?.map((e) => {
                return (
                  <div className="bg-blue-50 rounded-2xl mb-4 p-4" key={e}>
                    <div className="font-bold text-blue-900 py-3">
                      Dependant ({e + 1})
                    </div>
                    <div className="grid grid-cols-5 gap-3 py-2 font-bold text-blue-900">
                      <div>SIN number</div>
                      <div>First Name</div>
                      <div>Last Name</div>
                      <div>Relationship</div>
                      <div>Birth date</div>
                    </div>
                    <div className="grid grid-cols-5 gap-3 py-2">
                      <div>{users?.['DependantSin' + e]}</div>
                      <div>{users?.['DependantFirstName' + e]}</div>
                      <div>{users?.['DependantLastName' + e]}</div>
                      <div>{users?.['DependantRelation' + e]}</div>
                      <div>{users?.['DependantBod' + e]}</div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};
export default AdminAccount;
